import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { PurchaseInvoice } from '../types/purchase-invoice';
import { EnvService } from './env.service';


const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class PurchaseInvoiceService {

  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/purchase-invoice/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

    getReturnNo() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/purchase-invoice/getReturnNo`,httpOptions)
    .pipe(catchError(this.handleError));
        
    }

   getAll():Observable <any[]> {
    return this.http.get <any[]>(`${this.env.apiUrl}/purchase-invoice`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    getAllItems():Observable <any[]> {
      return this.http.get <any[]>(`${this.env.apiUrl}/purchase-invoice/getAllQtyPurchase`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

      getProductionItems():Observable <any[]> {
        return this.http.get <any[]>(`${this.env.apiUrl}/purchase-invoice/getProductionQty`,httpOptions)
        .pipe(catchError(this.handleError));
           
        }

    getGRN(grnNo):Observable <any> {
      return this.http.get<any>(`${this.env.apiUrl}/purchase-invoice/${grnNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }



    addGRN(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/purchase-invoice`, data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    addDebitNote(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/purchase-invoice/debitNote`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    deleteGRN(data,grnNo):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/purchase-invoice/${grnNo}`, data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteDebitNote(data,grnNo) : Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/purchase-invoice/debitNote/${grnNo}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }
 
    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       



}//end class
